import { applicationSettings } from '../../settings/application';
import { getProppingBounds } from '../products/models';
import Bror from './bror';
import Jonaxel from './jonaxel';
import Boaxel from './boaxel';
import Aurdal from './aurdal';
import Ivar from './ivar';
import Elvarli from './elvarli';
import { getAvailableProppingBounds } from './common';

function getRangeApi() {
  switch (applicationSettings.applicationName) {
    case 'BROR':
      return Bror;
    case 'JONAXEL':
      return Jonaxel;
    case 'BOAXEL':
      return Boaxel;
    case 'AURDAL':
      return Aurdal;
    case 'IVAR':
      return Ivar;
    case 'ELVARLI':
      return Elvarli;
    default:
      console.error(
        'Missing range-specific implementation of propping service'
      );
      return {};
  }
}

const rangeApi = getRangeApi();

function smallestPropping(proppingItem) {
  const proppingBounds = getProppingBounds(proppingItem);
  const allBounds = getAvailableProppingBounds(
    proppingBounds,
    Infinity,
    Infinity
  );
  return allBounds.pop();
}

function pickPropping(args) {
  throw new Error(
    'NotImplementedError',
    'Range-specific implementation needed'
  );
}

const api = {
  smallestPropping,
  pickPropping,
};

Object.assign(api, rangeApi);

export default api;
